import { useSelector, shallowEqual } from "react-redux";
//import type { RootState } from "../../../../_metronic/partials/widgets/store/Store";
import { RootState } from '../../../../setup/redux/Store'
import jwt from 'jwt-decode'
import { AccessToken_I } from '../models/AccessTokenModel'
import { useMemo } from 'react'

export const useAuth = () => {
    const accessToken = useSelector(
        (state: RootState) => state.auth.accessToken,
        shallowEqual
    )

    const roleList = useMemo(() => {
        if (!accessToken) return []

        const atJwt = jwt<AccessToken_I>(accessToken)
        return atJwt.roleIdList.split(',')
    }, [accessToken])

    return { accessToken, roleList }
}